import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LAUNCH_SPECIAL_END = new Date('2026-09-30T23:59:59Z');

export function getTimeRemaining() {
  const now = Date.now();
  const difference = LAUNCH_SPECIAL_END.getTime() - now;

  if (difference <= 0) {
    return null;
  }

  const day = 1000 * 60 * 60 * 24;
  const hour = 1000 * 60 * 60;
  const minute = 1000 * 60;

  return {
    days: Math.floor(difference / day),
    hours: Math.floor((difference % day) / hour),
    minutes: Math.floor((difference % hour) / minute),
    seconds: Math.floor((difference % minute) / 1000),
  };
}

function LaunchSpecialTimer({ hideWhenEnded = false }) {
  const { t } = useTranslation();
  const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setTimeRemaining(getTimeRemaining());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  if (!timeRemaining) {
    if (hideWhenEnded) {
      return null;
    }
    return (
      <div className="launch-special-timer ended">
        <span className="launch-special-kicker">{t('pricing.launchSpecial')}</span>
        <strong>{t('pricing.offerClosed')}</strong>
      </div>
    );
  }

  const segments = [
    { label: t('pricing.days'), value: timeRemaining.days },
    { label: t('pricing.hours'), value: timeRemaining.hours },
    { label: t('pricing.minutes'), value: timeRemaining.minutes },
    { label: t('pricing.seconds'), value: timeRemaining.seconds },
  ];

  return (
    <div className="launch-special-timer">
      <span className="launch-special-kicker">{t('pricing.endsLabel')}</span>
      <div className="launch-special-clock">
        {segments.map((segment) => (
          <div key={segment.label} className="launch-special-segment">
            <strong>{String(segment.value).padStart(2, '0')}</strong>
            <span>{segment.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LaunchSpecialTimer;
